import { createContext } from 'react';

export const PortalRoutesContext = createContext([]);
